export { DMS_MODULE } from '../constants';
export const NAME = 'LabourSales';
export const API_NAME = 'LabourSales';
export const EXPORT_FILE_NAME='LabourSales.xlsx';
export const CRUMB_LABEL_KEY = 'LabourSales';


export type SestavaButton = { labelKey: string, routeName: string, api: string, permission: number };
